import { X } from "@phosphor-icons/react";
import { Outlet } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

import AimfoxLogo from "assets/aimfoxLogos/aimfox-logo-text.svg?react";

export default function BaseLayout() {
  const { goBackToWorkspace } = useWorkspaceNavigate();

  return (
    <>
      <header className="flex h-20 items-center justify-between px-4 bg-white max-lg:shadow-sm relative">
        <AimfoxLogo />
        <Button
          intent="iconOnly"
          size="lg"
          variant="outline-black"
          className="lg:hidden"
          onClick={goBackToWorkspace}
        >
          <X />
        </Button>
      </header>

      <main className="bg-white flex flex-col lg:pt-1 p-4 min-h-[calc(100dvh-80px)]">
        <Outlet />
      </main>
    </>
  );
}
